import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a5cfb085dd08a0014bccbc8_1787412260325_e7229598/rifascamiganga/src/app/page.tsx");
